module.exports = __webpack_public_path__ + "img/space-introduce-4-en.5beeb652.svg";